/**
 * AiThinkingMessage — AI 응답 대기 중 placeholder 카드.
 *
 * 사용자가 /ai 메시지 send 직후 chatStore.aiPendingByRoom[roomId]=true 가 되며,
 * MessageList 가 마지막 위치에 본 컴포넌트 렌더. 실제 AI 응답 (isAi=true) 이 도착하면
 * appendMessage 가 자동으로 aiPending 을 false 로 → 본 컴포넌트 사라짐.
 *
 * 시각: AiTextMessage 와 동일 layout — Bot 아바타 + AI 비서 라벨 + 점 3개 펄스 애니메이션.
 */
import { AiAvatar } from '../../../components/AiAvatar';
import { tChat } from '../../../lib/chat-i18n';

interface AiThinkingMessageProps {
  /** orchestrator 가 도구 사용 중일 때 도구 이름 — 있으면 "도구 사용 중: <tool>" 으로 텍스트 분기. */
  tool?: string | null;
}

export function AiThinkingMessage({ tool }: AiThinkingMessageProps = {}) {
  const label = tool
    ? tChat('chat.ai_thinking.tool', { tool })
    : tChat('chat.ai_thinking.text');
  return (
    <div className="chat-message-row chat-message-row--show-avatar chat-message-row--ai-thinking">
      <div className="chat-message-avatar-slot">
        <div className="chat-message-avatar chat-message-avatar--ai" aria-label={tChat('chat.item.ai_assistant')}>
          <AiAvatar />
        </div>
      </div>
      <div className="chat-message-body">
        <div className="chat-message-meta">
          <span className="chat-message-sender">{tChat('chat.item.ai_assistant')}</span>
          <span className="chat-message-ai-badge">{tChat('chat.item.ai_badge')}</span>
        </div>
        <div className="chat-message-bubble-wrap">
          <div className="chat-message-bubble chat-message-bubble--ai chat-ai-thinking-bubble" role="status" aria-live="polite" aria-label={tChat('chat.ai_thinking.aria')}>
            <span className="chat-ai-thinking-text">{label}</span>
            <span className="chat-ai-thinking-dots" aria-hidden>
              <span className="chat-ai-thinking-dot" />
              <span className="chat-ai-thinking-dot" />
              <span className="chat-ai-thinking-dot" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
